(ns minorodata.components.connections.forms.conditionals
  "Whether a generated form's block should show, given the current field values.
   `test-conditions` is the entry point: a vector of vectors is the legacy
   language resolved here, anything else is handed to `conditionals-v2`."
  (:require
   ["date-fns" :refer [differenceInDays]]
   [clojure.string :as str]
   [minorodata.components.connections.forms.conditionals-v2 :as conditionals-v2]))


(defn resolve-condition [fields condition]
  (let [[matcher source val & options] condition]
    (case matcher
      :eq      (= val (get-in fields source))
      :not-nil (not (nil? (get-in fields source)))
      :not-blank (not (str/blank? (get-in fields source)))
      :diff-in-days (let [operation ((first options) {:gt < :lt >})
                          [first-date second-date] (map #(get-in fields %) source)]
                      (operation val (differenceInDays second-date first-date)))
      :and (= val (map #(get-in fields %) source))
      ;; Just return true when unsupported matcher is used
      true)))


(defn test-conditions [conditions fields]
  (cond
    (empty? conditions) true
    (sequential? (first conditions)) (some true? (map (partial resolve-condition fields) conditions))
    :else (conditionals-v2/resolve-condition fields conditions)))
